"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _TransitionableLogUsers = _interopRequireDefault(require("./TransitionableLogUsers"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function TransitionableLogs(_ref) {
  var transitionable = _ref.transitionable,
    currencyId = _ref.currencyId,
    stages = _ref.stages,
    logUsers = _ref.logUsers,
    _ref$hideSpent = _ref.hideSpent,
    hideSpent = _ref$hideSpent === void 0 ? false : _ref$hideSpent,
    _ref$hideAuthorized = _ref.hideAuthorized,
    hideAuthorized = _ref$hideAuthorized === void 0 ? false : _ref$hideAuthorized,
    emptyLabel = _ref.emptyLabel;
  var convertStep = (0, _react.useCallback)(function (step) {
    if (!step) return '---';
    return /*#__PURE__*/_react["default"].createElement(_commons.WflStatus, {
      stageId: step.stage_id,
      status: step.status,
      stages: stages
    });
  }, [stages]);
  var logs = (0, _react.useMemo)(function () {
    var _a;
    var src = (_a = transitionable.transition.logs) !== null && _a !== void 0 ? _a : [];
    var toNumber = function toNumber(date) {
      return date instanceof Date ? date.getTime() : date;
    };
    return src.sort(function (a, b) {
      return toNumber(b.date) - toNumber(a.date);
    });
  }, [transitionable]);
  var columns = (0, _react.useMemo)(function () {
    var base = [{
      title: (0, _core.translate)('logs.date'),
      converter: function converter(item) {
        return (0, _commons.formatDateTime)({
          date: item.date
        });
      },
      id: 'date'
    }, {
      title: (0, _core.translate)('logs.user_id'),
      converter: function converter(item) {
        return /*#__PURE__*/_react["default"].createElement(_TransitionableLogUsers["default"], {
          users: logUsers,
          userId: item.user_id,
          onBehalfOf: item.on_behalf_of,
          emptyLabel: emptyLabel
        });
      },
      id: 'user_id'
    }, {
      title: (0, _core.translate)('logs.from'),
      converter: function converter(item) {
        return convertStep(item.from);
      },
      id: 'from'
    }, {
      title: (0, _core.translate)('logs.to'),
      converter: function converter(item) {
        return convertStep(item.to);
      },
      id: 'to'
    }, {
      title: (0, _core.translate)('logs.spent'),
      converter: function converter(item) {
        return (0, _commons.formatCurrecy)({
          value: item.spent,
          currencyId: currencyId
        }) || '---';
      },
      id: 'spent',
      textAlign: 'right'
    }, {
      title: (0, _core.translate)('logs.authorized'),
      converter: function converter(item) {
        return (0, _commons.formatCurrecy)({
          value: item.authorized,
          currencyId: currencyId
        }) || '---';
      },
      id: 'authorized',
      textAlign: 'right'
    }, {
      title: (0, _core.translate)('logs.comments'),
      converter: function converter(item) {
        return item.comments || '---';
      },
      id: 'comments'
    }];
    return base.filter(function (el) {
      if (el.id === 'spent') {
        return !hideSpent;
      }
      if (el.id === 'authorized') {
        return !hideAuthorized;
      }
      return true;
    });
  }, [logUsers, currencyId, hideSpent, hideAuthorized, emptyLabel, convertStep]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: logs,
    empty: (0, _core.translate)('logs.empty'),
    loading: false,
    getId: function getId(item) {
      var _a;
      return "".concat(item.date, "_").concat((_a = item.comments) !== null && _a !== void 0 ? _a : '-');
    },
    columns: columns
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TransitionableLogs);